module.exports = __webpack_public_path__ + "static/media/duo-lockup-horizontal-dark.070b262e.svg";